import previewImg from "@/assets/chrome-tab-picker-preview.png";

export function ChromeTabPickerPreview() {
  return (
    <div className="w-full overflow-hidden rounded-xl">
      <img
        src={previewImg}
        alt=""
        aria-hidden
        loading="lazy"
        className="block h-auto w-full select-none"
        draggable={false}
      />
    </div>
  );
}
